import { type ComponentPropsWithoutRef, type ElementType, type ReactNode } from "react";
import { styled } from "~/common/mui";

type Props<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  tag?: T;
  children?: ReactNode;
};

const StyledTitle = styled("h1")(({ theme }) => ({
  ...theme.typography.headlineSmall,
  marginTop: 0,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("tablet")]: {
    ...theme.typography.headlineMedium,
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.up("desktop-s")]: {
    marginBottom: theme.spacing(4),
  },
  "&::after": {
    [theme.breakpoints.up("tablet")]: {
      content: '""',
      display: "flex",
      width: "100%",
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(1),
    },
  },
}));

/**
 * @deprecated
 * Please use PageElements.Title instead
 */
export const PageTitle = <T extends ElementType = "h1">(props: Props<T>) => {
  const { className, tag = "h1", ...rest } = props;

  return <StyledTitle as={tag} className={className} {...rest} />;
};
